import { Field } from 'formik';
import React from 'react';
import { Accordion, Card, Col, Row } from 'react-bootstrap';
import { FormikNumber } from '../../../components';

const ToleranceTab = ({ currentTab, disabled, errors, flexibleShift, onChangeTab, setFieldValue, touched, values }) => {
  return (
    <Card className="overflow-visible">
      <Col className={`${currentTab === 'tolerance' ? 'top-header-green' : 'top-header-light-gray'}`}>
        <Accordion.Toggle
          as={Col}
          eventKey="1"
          className="card-header-title-dt"
          onClick={() => onChangeTab('tolerance')}
        >
          Tolerancia
        </Accordion.Toggle>
      </Col>
      <Accordion.Collapse eventKey="1">
        <Card.Body className="div-content">
          <Row>
            <Col xs={6} md={3}>
              <Field name="shift[parsedTolerance]">
                {({ field }) => (
                  <FormikNumber
                    {...field}
                    abbr={!flexibleShift}
                    label="Entrada Jornada"
                    rightAddon="min"
                    placeholder="0"
                    fieldName="shift[tolerance]"
                    value={values.shift.tolerance}
                    tooltipSize="21"
                    tooltipText="Minutos de tolerancia para el ingreso de jornada"
                    setFieldValue={setFieldValue}
                    disabled={flexibleShift || disabled}
                    errors={errors}
                    touched={touched}
                  />
                )}
              </Field>
            </Col>
            <Col xs={6} md={3}>
              <Field name="shift[parsedExitTolerance]">
                {({ field }) => (
                  <FormikNumber
                    {...field}
                    abbr={!flexibleShift}
                    label="Salida Jornada"
                    rightAddon="min"
                    placeholder="0"
                    fieldName="shift[exitTolerance]"
                    value={values.shift.exitTolerance}
                    tooltipSize="21"
                    tooltipText="Minutos de tolerancia para la salida de jornada"
                    setFieldValue={setFieldValue}
                    disabled={flexibleShift || disabled}
                    errors={errors}
                    touched={touched}
                  />
                )}
              </Field>
            </Col>
            <Col xs={6} md={3}>
              <Field name="shift[parsedArrivalBreakTolerance]">
                {({ field }) => (
                  <FormikNumber
                    {...field}
                    abbr={!flexibleShift}
                    label="Entrada Colación"
                    rightAddon="min"
                    placeholder="0"
                    fieldName="shift[arrivalBreakTolerance]"
                    value={values.shift.arrivalBreakTolerance}
                    tooltipSize="21"
                    tooltipText="Minutos de tolerancia para el ingreso de colación"
                    setFieldValue={setFieldValue}
                    disabled={flexibleShift || disabled}
                    errors={errors}
                    touched={touched}
                  />
                )}
              </Field>
            </Col>
            <Col xs={6} md={3}>
              <Field name="shift[parsedDepartureBreakTolerance]">
                {({ field }) => (
                  <FormikNumber
                    {...field}
                    abbr={!flexibleShift}
                    label="Salida Colación"
                    rightAddon="min"
                    placeholder="0"
                    fieldName="shift[departureBreakTolerance]"
                    value={values.shift.departureBreakTolerance}
                    tooltipSize="21"
                    tooltipText="Minutos de tolerancia para la salida de colación"
                    setFieldValue={setFieldValue}
                    disabled={flexibleShift || disabled}
                    errors={errors}
                    touched={touched}
                  />
                )}
              </Field>
            </Col>
          </Row>
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
};
export default ToleranceTab;
